import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-coverages-modal',
  templateUrl: './coverages-modal.component.html',
  styleUrls: ['./coverages-modal.component.scss'],
})
export class CoveragesModalComponent {
  @Input() open: boolean;
  @Output() close = new EventEmitter();
  current: string;
}
